{
  "en": {
    "common": {
      "search": "Search",
      "selected": "Selected"
    }
  }
}
